"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactImmutableProptypes = _interopRequireWildcard(require("react-immutable-proptypes"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _LocalInteraction = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/local/LocalInteraction"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _immutable = require("immutable");

/*
  Adds autosave support to an interaction.  LocalSettings are used to autosave the interaction.
*/
var propTypes = {
  attachments: (0, _reactImmutableProptypes.listOf)(_react.PropTypes.object).isRequired,
  children: _react.PropTypes.node,
  descriptor: _react.PropTypes.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  localInteraction: _react.PropTypes.instanceOf(_LocalInteraction.default).isRequired,
  onInteractionChange: _react.PropTypes.func,
  gates: _react.PropTypes.shape({
    get: _react.PropTypes.func.isRequired
  }),
  associations: _reactImmutableProptypes.default.map
};
var defaultProps = {
  onInteractionChange: _emptyFunction.default
};

var _default = function _default(InteractionComponent) {
  var InteractionWithAutoSave =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(InteractionWithAutoSave, _Component);

    function InteractionWithAutoSave() {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithAutoSave);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithAutoSave).call(this));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.doAutosave = _this.doAutosave.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(InteractionWithAutoSave, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        this.autosave = (0, _debounce.default)(500, this.doAutosave);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.attachments !== nextProps.attachments) {
          this.autosaveAttachments(nextProps);
        }
      }
    }, {
      key: "autosaveAttachments",
      value: function autosaveAttachments(props) {
        var localInteraction = this.props.localInteraction;
        var attachments = props.attachments;
        localInteraction.set('attachments', attachments);
        (0, _Interactions.saveLocalInteraction)(localInteraction);
      }
    }, {
      key: "doAutosave",
      value: function doAutosave(status) {
        var _this$props = this.props,
            localInteraction = _this$props.localInteraction,
            _this$props$descripto = _this$props.descriptor,
            localTransforms = _this$props$descripto.localTransforms,
            type = _this$props$descripto.type,
            attachments = _this$props.attachments;
        localInteraction.setType(type);
        localInteraction.set('attachments', attachments);
        (0, _Interactions.saveLocalInteraction)(localInteraction, status.interaction, localTransforms);
      }
    }, {
      key: "handleSaveToLocalStorage",
      value: function handleSaveToLocalStorage(status) {
        if (status != null) {
          status.interaction = status.interaction.set('savable', status.savable);

          if (this.props.gates && this.props.gates.get('CRM:RestoreLocalAssociations')) {
            this.props.associations.forEach(function (idsToAdd, objectTypeKey) {
              status.interaction = status.interaction.updateIn(['associations', objectTypeKey], function () {
                var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Set)();
                return ids.concat(idsToAdd);
              });
            });
          }

          this.doAutosave(status);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          onInteractionChange: this.props.onInteractionChange,
          onSaveToLocalStorage: this.handleSaveToLocalStorage
        }), this.props.children);
      }
    }]);
    return InteractionWithAutoSave;
  }(_react.Component);

  InteractionWithAutoSave.propTypes = propTypes;
  InteractionWithAutoSave.defaultProps = defaultProps;
  return InteractionWithAutoSave;
};

exports.default = _default;
module.exports = exports.default;